// PayPal Service for International Payments
import { httpsCallable } from 'firebase/functions';
import { functions } from '../utils/firebase-config';

// Start a PayPal subscription for customers outside India. The backend checks the plan price,
// records the pending subscription and returns PayPal's approval page to send the customer to.
export const startPayPalCheckout = async (billingCycle) => {
  const start = httpsCallable(functions, 'createPayPalSubscription');
  const result = await start({ billingCycle });
  if (!result.data?.approvalUrl) throw new Error('PayPal did not return a checkout link');
  return result.data.approvalUrl;
};

// Confirm a subscription when the customer returns from PayPal. PayPal can take a few seconds
// to record the first payment, so callers retry while this reports that it is still pending.
export const confirmPayPalSubscription = async (subscriptionId) => {
  const confirm = httpsCallable(functions, 'activatePayPalSubscription');
  const result = await confirm({ subscriptionId });
  return result.data;
};

// Cancel PayPal subscription
export const cancelPayPalSubscription = async (subscriptionId) => {
  const cancelSubscription = httpsCallable(functions, 'cancelPayPalSubscription');
  
  try {
    const result = await cancelSubscription({ subscriptionId });
    return result.data;
  } catch (error) {
    console.error('Cancel PayPal subscription error:', error);
    throw error;
  }
};

// Decide India vs international pricing from the device timezone. India has a single
// timezone, and this needs no third-party service (the free IP lookup used before now
// rate-limits, which wrongly showed international pricing to Indian visitors).
export const detectUserCountry = async () => {
  let timeZone = '';
  try { timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch { /* unknown */ }
  if (!timeZone) return { country: null, countryName: null, isIndia: null };
  const isIndia = ['Asia/Kolkata', 'Asia/Calcutta'].includes(timeZone);
  return { country: isIndia ? 'IN' : null, countryName: isIndia ? 'India' : null, isIndia };
};

// Get recommended payment method based on country
export const getRecommendedPaymentMethod = async () => {
  const location = await detectUserCountry();
  
  if (location.isIndia === true) {
    return {
      primary: 'razorpay',
      secondary: 'paypal',
      location
    };
  } else if (location.isIndia === false) {
    return {
      primary: 'paypal',
      secondary: 'razorpay',
      location
    };
  } else {
    // Detection failed - show both
    return {
      primary: 'both',
      secondary: null,
      location
    };
  }
};
